import React from 'react';
import { Route, Switch } from 'react-router-dom';

import DrawList from './DrawList';
import DrawManager from './DrawManager';

const Draw = ({ match }) => (
  <Switch>
    <Route exact path={`${match.url}/`} component={DrawList} />
    <Route path={`${match.url}/manager/:id?`} component={DrawManager} />
  </Switch>
);

export default Draw;
